import { render } from "./MkIceCream.vue?vue&type=template&id=5053351f&scoped=true"
import script from "./MkIceCream.vue?vue&type=script&lang=js"
export * from "./MkIceCream.vue?vue&type=script&lang=js"

import "./MkIceCream.vue?vue&type=style&index=0&id=5053351f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5053351f"]])

export default __exports__